import React from 'react';
import GSTRechargeModal from './GSTRechargeModal';

const BuyCreditsModal = ({ open, onClose }) => {
  return <GSTRechargeModal open={open} onClose={onClose} />;
};

export default BuyCreditsModal;